<template>
    <div class="documents">
        <div class="drop-file">
            <b-card no-body class="p-3">
                <b-row>
                    <b-col md="6" cols="12">
                        <div class="mb-md-4 mt-md-0 my-4">
                            <h3>Choose Doc Category</h3>
                            <el-select v-model="attachment_category_id" placeholder="Select">
                                <el-option
                                v-for="item in categories"
                                :key="item.attachment_category_id"
                                :label="item.name"
                                :value="item.attachment_category_id">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <h3>Remark</h3>
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="Type your remark here"
                                v-model="remark">
                            </el-input>
                        </div>
                    </b-col>
                    <b-col md="6" cols="12">
                        <vue-dropzone 
                            id="dropzone"
                            ref="dropzone"
                            :options="dropzoneOptions" 
                            :useCustomSlot=true
                            v-on:vdropzone-sending="sendingDropzone"
                            v-on:vdropzone-success="successDropzone"
                            v-on:vdropzone-error="errorDropzone"
                            v-on:vdropzone-queue-complete="queueCompleteDropzone"
                        >
                            <b-icon icon="cloud-arrow-up-fill" font-scale="4"></b-icon>
                            <p class="mb-0">Drag and Drop Upload or</p>
                            <el-button type="text">Click to Browse</el-button>
                        </vue-dropzone>
                        <small>10 Maximum files per upload.</small>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div class="document-listing">
            <div class="listing-header">
                <b-row class="d-flex justify-content-between">
                    <b-col md="6">
                        <b-row>
                            <b-col md="6" cols="12">
                                <base-input
                                    v-model="searchQuery"
                                    prepend-icon="fas fa-search"
                                    placeholder="Search..."
                                >
                                </base-input>
                            </b-col>
                            <b-col md="6" cols="12">
                                <base-input>
                                    <el-select v-model="filterByCategoryId" placeholder="Select">
                                        <el-option selected value="">All</el-option>
                                        <el-option
                                        v-for="item in categories"
                                        :key="item.attachment_category_id"
                                        :label="item.name"
                                        :value="item.attachment_category_id">
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </b-col>
                        </b-row>
                    </b-col>
                    <!-- <b-col md="4">
                        <div class="block">
                            <el-date-picker
                                v-model="filterByDate"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="Start date"
                                end-placeholder="End date">
                            </el-date-picker>
                        </div>
                    </b-col> -->
                </b-row>
            </div>
            <div class="listing-table bg-white">
                <b-row class="mt-4 mt-md-0">
                    <b-col cols="10" class="px-4 py-3">
                        <h3>Uploaded Documents</h3>
                    </b-col>
                    <b-col cols="2" class="px-4 py-3 float-right" v-if="showBulkAction">
                        <a href="javascript:void(0)" @click.prevent="bulkDownload(selectedRows)" class="table-action mr-3" data-toggle="tooltip" data-original-title="Download">
                            <i class="fa fa-download text-primary"></i>
                        </a>
                        <a 
                            href="javascript:void(0)" 
                            @click.prevent="bulkRemoveAttachment(selectedRows)" 
                            class="table-action" 
                            data-toggle="tooltip" 
                            data-original-title="Remove"
                        >
                            <i class="fa fa-trash text-danger"></i>
                        </a>
                    </b-col>
                    <b-col cols="12">
                        <el-table
                            ref="multipleTable"
                            :data="queriedData"
                            style="width: 100%"
                            max-height="350"
                            @selection-change="selectionChange"
                        >
                            <el-table-column
                                type="selection"
                                width="55"
                            ></el-table-column>
                            <el-table-column
                                prop="attachment_id"
                                label="Id"
                                width="90"
                            >
                            </el-table-column>
                            <el-table-column
                                label="original filename"
                                width="300"
                            >
                                <template scope="scope">
                                    
                                    <a href="javascript:void(0)"  
                                        class="text-primary font-weight-bold"
                                        @click="$refs.preview_modal.preview(scope.row.url, scope.row.display_filename)">
                                        {{ scope.row.display_filename }}
                                    </a>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="category"
                                label="Category"
                                min-width="200">
                                <template scope="scope">
                                    <select v-model="scope.row.attachment_category_id" class="border-0" style="outline:none" @change="updateAttachment(scope.row)">
                                        <option value="">-</option>
                                        <option
                                        v-for="item in categories"
                                        :key="item.attachment_category_id"
                                        :label="item.name"
                                        :value="item.attachment_category_id">
                                        </option>
                                    </select>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Updated By"
                                min-width="180">
                                <template scope="scope">
                                    <div v-if="scope.row.updated_by_detail">{{ scope.row.updated_by_detail.name }}</div>
                                    <div v-else>N/A</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="updated_at"
                                label="Updated Date"
                                min-width="180">
                                <template scope="scope">
                                    <div>{{ scope.row.updated_at | dateTimeFormatString }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="remark"
                                label="Remarks"
                                min-width="250">
                            </el-table-column>
                            <el-table-column min-width="80px" align="center">
                                <div slot-scope="{row}" class="table-actions">
                                    <a href="javascript:void(0)" @click.prevent="download(row)" class="table-action mr-3" data-toggle="tooltip" data-original-title="Download">
                                        <i class="fa fa-download text-primary"></i>
                                    </a>
                                    <a 
                                        href="javascript:void(0)" 
                                        @click.prevent="removeAttachment(row)" 
                                        class="table-action" 
                                        data-toggle="tooltip" 
                                        data-original-title="Remove"
                                        v-if="row.created_by == auth_user.id"
                                    >
                                        <i class="fa fa-trash text-danger"></i>
                                    </a>
                                </div>
                            </el-table-column>
                        </el-table>
                    </b-col>
                </b-row>
            </div>
        </div>
        <PreviewModal ref="preview_modal"></PreviewModal>
    </div>
</template>
<script>
    import { Card, Button, Tag, Select, Option, Input, DatePicker, Table, TableColumn } from 'element-ui'
    import vue2Dropzone, { methods } from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import { BasePagination } from '@/components'
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import debounce from 'lodash.debounce'
    import {axios, services, getHeader } from '@/assets/js/httpImports.js'
    import PreviewModal  from '@/components/Modal/PreviewModal'
    import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
    import { useAuthStore } from '@/stores/authStore'
    import { mapState } from 'pinia'
    
    export default {
        name: 'documents',
        props: ['base_url', 'retrieve_url'],
        mixins: [notifyFunctionMixin,clientPaginationMixin, helperFunctionMixin],
        components: {
            vueDropzone: vue2Dropzone,
            BasePagination,
            [Card.name]: Card,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Select.name]: Select,
            [Option.name]: Option,
            [Input.name]: Input,
            [DatePicker.name]: DatePicker,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            PreviewModal
        },
        data() {
            return {
                 dropzoneOptions: {	
                    url: this.base_url,
                    addRemoveLinks: false,
                    maxFiles: 10,
                    headers: {...getHeader(), "Cache-Control": ""},
                },
                categories: [],
                remark: '',
                attachment_category_id: '',
                debouncedHandler: '',
                filterByDate: '',
                tableData: [],
                orginalTableData: [],
                showBulkAction: false,
                allowDeleteRoles:['role_admin', 'role_admin_support', 'role_it_admin', 'role_corporate', 'role_super_admin', 'role_manager'],
                filterByCategoryId: '',
                propsToSearch:['original_filename'],
                vpsSpecialIdForDelete: [337,338,339,340],
                selectedRows: [],
            }
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user']),
        },
        created(){
            this.getAttachmentCategories()
            this.getAttachments()
        },
        watch:{
            filterByCategoryId(){
                if(this.filterByCategoryId !== ""){
                    this.tableData = this.orginalTableData.filter((item) => 
                        item.attachment_category && item.attachment_category.attachment_category_id === this.filterByCategoryId
                    )
                    return
                }
                this.tableData = [...this.orginalTableData]
            }
        },
        methods: {
            removeAttachment(row){
                let message = 'Are you sure you want to remove the attachment ?'
                if(confirm(message) == true){
                    axios.delete(services.attachment + 'attachments/' + row.attachment_id, {headers: getHeader(),})
                    .then(res => {
                        this.tableData = this.tableData.filter((item) => item.attachment_id != row.attachment_id)
                        this.orginalTableData = this.orginalTableData.filter((item) => item.attachment_id != row.attachment_id)
                        this.notifySuccess('<b>Attachment</b> - Successfully Removed.')
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    });   
                }
            },
            bulkRemoveAttachment(selectedRows){
                let message = 'Are you sure you want to remove the attachment ?'
                let attachment_ids = [];
                let promises = [];

                if(confirm(message) == true){
                    selectedRows.forEach(item => {
                        if(item.created_by == this.auth_user.id || this.vpsSpecialIdForDelete.includes(this.auth_user.id))
                        {
                            let promise = axios.delete(services.attachment + 'attachments/' + item.attachment_id, {headers: getHeader(),})
                            .then(res => {
                                if(res.status == 200) {
                                    attachment_ids.push(item.attachment_id)
                                }
                            })
                            .catch(e => {
                                this.errorFunction(e)
                            });   
                            promises.push(promise)
                        }
                    })

                    Promise.all(promises).then(() => {
                        if(attachment_ids.length > 0)
                        {
                            this.tableData = this.tableData.filter((item) => !attachment_ids.includes(item.attachment_id))
                            this.orginalTableData = this.orginalTableData.filter((item) => !attachment_ids.includes(item.attachment_id))
                            this.notifySuccess('<b>Attachment</b> - Successfully Removed.')
                        }
                        else
                        {
                            this.notifyError('<b>You dont have access to delete these attachment.</b>')
                        }
                    })
                }
            },
            updateAttachment(row){
                let new_atth_cat_id = row.attachment_category_id ?? null
                let data = {
                    attachment_category_id: new_atth_cat_id
                }
                axios.put(services.attachment + 'attachments/' + row.attachment_id, data, {headers: getHeader(),})
                .then(res => {
                    // replace data
                    const newData = res.data.data
                    newData.display_filename = newData.attachment_category ? newData.attachment_category.name + ' - ' + newData.original_filename : newData.original_filename
                    
                    let newTableData = []
                    for(let i = 0; i < this.tableData.length; i++){
                        if(this.tableData[i].attachment_id == newData.attachment_id){
                            this.tableData[i] = newData
                        }
                        newTableData.push(this.tableData[i])
                    }
                    let index = this.orginalTableData.findIndex(item => item.attachment_id === newData.attachment_id);
                    if (index !== -1) {
                        this.orginalTableData.splice(index, 1, newData);
                    }
                    this.tableData = newTableData
                    // this.orginalTableData = newTableData

                    this.notifySuccess('<b>Attachment</b> - Successfully Updated.')
                })
                .catch(e => {
                    this.errorFunction(e)
                });
            },
            download(row){
                axios.get(services.attachment + 'attachments/' + row.attachment_id + '/download',{
                    headers: getHeader(),
                    responseType: 'blob'
                })
                .then(response => {
                    this.createDownloadFileLink(response.data, row.display_filename)
                })
                .catch(e => {
                    this.errorFunction(e)
                });
            },
            bulkDownload(selectedRows){
                selectedRows.forEach(row => {
                    axios.get(services.attachment + 'attachments/' + row.attachment_id + '/download',{
                        headers: getHeader(),
                        responseType: 'blob'
                    })
                    .then(response => {
                        this.createDownloadFileLink(response.data, row.display_filename)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    });
                })
            },
            errorDropzone(file, message, xhr){
                file.previewElement.querySelectorAll('.dz-error-message span')[0].textContent = message.message;
                this.errorFunction(xhr, message.message)
            },
            successDropzone(file, response){
                const res = response.data;
                let modifiedData = {
                    ...res,
                    display_filename: res.attachment_category ? res.attachment_category.name + ' - ' + res.original_filename : res.original_filename
                }
                if (!this.orginalTableData.find(item => item.attachment_id === modifiedData.attachment_id)) {
                    this.orginalTableData.unshift(modifiedData)
                    if (this.filterByCategoryId === "" || (modifiedData.attachment_category && modifiedData.attachment_category.attachment_category_id === this.filterByCategoryId)) {
                        this.tableData.unshift(modifiedData)
                    }
                }
                setTimeout(() => {
                    this.$refs.dropzone.removeFile(file)
                }, 1000);                
            },
            queueCompleteDropzone() {
                this.remark = ''
                this.attachment_category_id = ''
            },
            sendingDropzone(file, xhr, formData){
                if(this.remark){
                    formData.append('remark', this.remark)
                }
                if(this.attachment_category_id){
                    formData.append('attachment_category_id', this.attachment_category_id)
                }
            },
            selectionChange(selectedRows) {
                this.selectedRows = selectedRows
                this.showBulkAction = (selectedRows.length > 0)
            },
            // getAttachments(){
            //     let url = this.retrieve_url ? this.retrieve_url : this.base_url
            //     axios.get(url, {headers: getHeader()})
            //         .then(res => {
            //             let modifiedData = res.data.data.map(obj => ({ ...obj, 
            //                 display_filename: obj.attachment_category ? obj.attachment_category.name + ' - ' + obj.original_filename : obj.original_filename
            //             }))
            //             this.tableData = modifiedData
            //             this.orginalTableData = modifiedData
            //         })
            //         .catch(e => {
            //             this.errorFunction(e)
            //         })
            // },

          //FILTER BY CATEGORY
            getAttachments() {
              let url = this.retrieve_url ? this.retrieve_url : this.base_url;
              axios
                .get(url, { headers: getHeader() })
                .then(res => {
                  let modifiedData = res.data.data
                    // ✅ filter out Client Cashback Summary
                    .filter(obj => {
                      const categoryName = obj.attachment_category?.name
                        ? obj.attachment_category.name.trim().toLowerCase()
                        : "";
                      return categoryName !== "client cashback summary";
                    })
                    // ✅ add display_filename
                    .map(obj => ({
                      ...obj,
                      display_filename: obj.attachment_category
                        ? obj.attachment_category.name + " - " + obj.original_filename
                        : obj.original_filename
                    }));

                  this.tableData = [...modifiedData];
                  this.orginalTableData = [...modifiedData];
                })
                .catch(e => {
                  this.errorFunction(e);
                });
            },
            // getAttachmentCategories(){
            //     axios.get(services.attachment + 'attachment/categories', {headers: getHeader()})
            //         .then(res => {
            //             this.categories = res.data.data
            //         })
            //         .catch(e => {
            //             this.errorFunction(e)
            //         })
            // },
            getAttachmentCategories() {
              axios
                .get(services.attachment + 'attachment/categories', { headers: getHeader() })
                .then(res => {
                  let data = res.data.data || [];

                  // ✅ Remove only the word "CTOS" from each item name
                  data = data.map(item => {
                    if (!item || !item.name) return item;

                    // Remove the word CTOS anywhere (case-insensitive)
                    item.name = item.name.replace(/CTOS\s*/gi, '').trim();

                    return item;
                  });

                  this.categories = data;
                })
                .catch(e => {
                  this.errorFunction(e);
                });
            },
        }
    }
</script>